'use strict';

var Mirror = require('./utils').mirror;

module.exports = Mirror('@@auth-status', {
    INIT: true,
    WAITING: true,
    WAITING_LOGOUT: true,
    FINISHED: true
});


//////////////////
// WEBPACK FOOTER
// ./~/strange-auth/lib/statuses.js
// module id = 597
// module chunks = 0